import { getFromApi, getApiUrl, postToApi } from "../lib/api";
import English from "@/lib/js/english";
import Spanish from "@/lib/js/spanish";

// Function to detect browser locale and map to supported locales
const detectBrowserLocale = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const locale = localStorage.getItem('locale');

  // If user has explicitly set a locale, use that
  if (locale) return locale;

  // Map browser language to supported locales
  // Spanish variants: es, es-ES, es-CO, es-MX, etc. -> es_CO
  // English variants: en, en-US, en-GB, etc. -> en_US
  if (browserLang.toLowerCase().startsWith('es')) {
    return 'es_CO';
  }
  if (browserLang.toLowerCase().startsWith('en')) {
    return 'en_US';
  }

  // Default to Spanish if not detected
  return 'es_CO';
};

const useTranslations = () => {

  const packageName = 'cc.zono.mktplace'
  const [locale, setLocale] = React.useState(detectBrowserLocale());
  const [translations, setTranslations] = React.useState(null)

  // Initialize translations from modules on mount and when locale changes
  React.useEffect(() => {
    // First try localStorage for API-translated content
    const stored = localStorage.getItem('translations');
    if (stored) {

      let ls = JSON.parse(stored)

      // merge translations
      if (locale === 'es_CO') {
        ls = { ...ls, ...Spanish }
      } else {
        ls = { ...ls, ...English }
      }
      console.log("set translations", ls)
      setTranslations(ls);
    } else {
      
    }

  }, [locale]);

  function getTranslations(user) {

    if (window.translations && window.translations.length > 0) {
      let trans = window.translations.reduce((a, v) => ({ ...a, [v.name.toLowerCase()]: v.value }), {})

      console.log("translations from window", trans)
      //console.log("test", tr("Last 6 Months", trans))

      setTranslations(trans)
      localStorage.setItem("translations", JSON.stringify(trans));

    } else {
      const url = getApiUrl(`/api/v1/translation/app/${packageName}/${locale}`)

      // console.log('getTranslations', url)

      getFromApi(`/api/v1/translation/app/${packageName}/${locale}`, {}, (response) => {
        //console.log("translations result", response.result)

        // convert the translations array into a map
        let trans = response.result.reduce((a, v) => ({ ...a, [v.name.toLowerCase()]: v.value }), {})

        console.log("translations result", trans)
        //console.log("test", tr("Last 6 Months", trans))

        setTranslations((prev) => {
          const ls = {...prev, ...trans}
          console.log("set translations", ls)
          return ls})

        localStorage.setItem("translations", JSON.stringify(trans));
      }, (error) => {
        console.log(url, error)
      })
    }

  }


  function tr(key) {
    if (!translations) return key

    if (translations[key.toLowerCase()])
      return translations[key.toLowerCase()]

    // only add translations for en_US, en_GB and es_CO
    /*  if (locale === 'en_US' || locale === 'en_GB' || locale === 'es_CO') {

       // the translation item does not exist in this locale so add a translation item
       // with the key for future translation
       let map = {
         id: 0,
         locale: locale,
         model: 'business',
         appName: packageName,
         name: key,
         value: key,
         translate: true
       }

       postToApi('/api/v1/translation/', { id: 0 }, map, (result) => {

       }, (error) => {
         console.log("error adding translation", error)
       })
     } */

    // save the key as the translation to avoid repeated adds to the API
    //translations[key.toLowerCase()] = key

    //console.log("not found", key, translations.length, translations["Extra charges may apply"])

    return key
  }


  const trmap = (key, map) => {
    let text = tr(key)

    //console.log("translate with", key, map)

    Object.keys(map).forEach((key) => {
      //let repl = `{${key.toUpperCase()}}`
      //console.log("replace", repl, "with", map[key])
      text = text.replaceAll(`{${key.toUpperCase()}}`, map[key])

      //console.log("replaced result", text)
    })

    return text
  }

  // Update locale setter to also persist to localStorage and update translations
  const handleSetLocale = (newLocale) => {
    setLocale(newLocale);
    localStorage.setItem('locale', newLocale);
    // Update translations immediately when locale changes
    if (newLocale === 'es_CO') {
      setTranslations(Spanish);
    } else {
      setTranslations(English);
    }
  };

  return {
    tr,
    trmap,
    getTranslations,
    locale,
    setLocale: handleSetLocale,
    translations,
    setTranslations,
  };

}

export default useTranslations;
